import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Salerno Streamerpanel. Alle Rechte vorbehalten.</p>
    </footer>
  );
}
